import accounts from './account.js';
import errors from './error.js';
import guests from './guest.js';
import tenant from './tenant.js';

export default [
    ...tenant,
    ...guests,
    ...accounts,
    ...errors, // Must be last
];
